import { centralSignOut } from './centralAuth';
type ErrorCallback = (error: string) => void;
export class AuthService {
  private onError: ErrorCallback[] = [];
  public errorSubscribe(listener: ErrorCallback) { this.onError.push(listener); }
  public errorUnSubscribe(listener: ErrorCallback) { this.onError = this.onError.filter(item => item !== listener); }
  public SignOut = (): void => {
    void centralSignOut().catch(error => {
      if (this.onError.length) this.onError.forEach(listener => listener(error.message));
      else window.alert(error.message);
    });
  };
}
